export const VIP_IDLE_WARNING_MS = 10 * 60 * 1000;
export const VIP_IDLE_LOGOUT_MS = 15 * 60 * 1000;
export const VIP_LAST_ACTIVITY_KEY = "vips:lastActivityAt";

export const getVipIdlePhase = (idleMs) => {
  if (idleMs >= VIP_IDLE_LOGOUT_MS) return "logout";
  if (idleMs >= VIP_IDLE_WARNING_MS) return "warning";
  return "active";
};

export const getVipIdleRemainingMs = (idleMs) =>
  Math.max(0, VIP_IDLE_LOGOUT_MS - idleMs);

export const formatIdleDuration = (durationMs) => {
  const totalSeconds = Math.max(1, Math.round(durationMs / 1000));
  if (totalSeconds < 60) {
    return `${totalSeconds} second${totalSeconds === 1 ? "" : "s"}`;
  }
  const minutes = Math.round(totalSeconds / 60);
  return `${minutes} minute${minutes === 1 ? "" : "s"}`;
};

export const formatIdleCountdown = (remainingMs) => {
  const totalSeconds = Math.max(0, Math.ceil(remainingMs / 1000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${String(seconds).padStart(2, "0")}`;
};
